import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { getData, postData } from '../Services/api'
import { toast } from 'react-toastify'
import JoditEditor from 'jodit-react';
import avtar5 from '../../assets/images/user/avatar-5.jpg'
const AddBanner = () => {
    const editor = useRef(null);
    const [values, setValues] = useState({
        title: "",
        offerText: "",
        highlightText:"",
        description: "",
        btn1Text: "",
        btn1Link: "",
        btn2Text: "",
        btn2Link: "",
        backgroundImage: null,
    })

    const [loading, setLoading] = useState(false)

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValues(prev => ({
                ...prev,
                backgroundImage: file,
            }));
        }
    };


    const fetchBanners = async () => {
        try {
            const res = await getData('/banners');
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch banner", error)
        }
    }

    useEffect(() => {
        fetchBanners();
    }, []);

    const validateBanner = () => {
        const {
            title = "",
            offerText = "",
            highlightText = "",
            btn1Text = "",
            btn1Link = "",
            btn2Text = "",
            btn2Link = "",
            description = ""
        } = values;

        if (!title.trim()) {
            toast.error("Banner title is required.");
            return false;
        }

        if (!offerText.trim()) {
            toast.error("Offer Text is required.");
            return false;
        }

        if (!description.trim()) {
            toast.error("Description is required.");
            return false;
        }

        if (!btn1Text.trim()) {
            toast.error("Button 1 Text is required.");
            return false;
        }
        if (!highlightText.trim()) {
            toast.error("Highlight Text is required.");
            return false;
        }

        if (!btn1Link.trim()) {
            toast.error("Button 1 Link is required.");
            return false;
        }

        if (!btn2Text.trim()) {
            toast.error("Button 2 Text is required.");
            return false;
        }

        if (!btn2Link.trim()) {
            toast.error("Button 2 Link is required.");
            return false;
        }

        return true;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateBanner()) return;
        setLoading(true)
        try {
            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('description', values.description);
            formData.append('offerText', values.offerText);
            formData.append('highlightText', values.highlightText);
            formData.append('btn1Text', values.btn1Text);
            formData.append('btn1Link', values.btn1Link);
            formData.append('btn2Text', values.btn2Text);
            formData.append('btn2Link', values.btn2Link);
            if (values.backgroundImage) {
                formData.append('backgroundImage', values.backgroundImage);
            }
            const res = await postData('/banners', formData);
            if (res.status) {
                toast.success(res.message)
            }
        } catch (error) {
            console.log("error testimonials adding",)
            toast.error(error.data.response.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Update Banner
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Update Banner</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Update Banner</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-12 mb-3">
                                                <label htmlFor="avatar" className="form-label">Banner Image</label>
                                                <input
                                                    type="file"
                                                    id="avatar"
                                                    className="form-control"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                />

                                                {values.backgroundImage && (
                                                    <img
                                                        src={
                                                            values.backgroundImage
                                                                ? typeof values.backgroundImage === 'string'
                                                                    ? `${values.backgroundImage}`
                                                                    : URL.createObjectURL(values.backgroundImage)
                                                                : avtar5
                                                        }
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                    />
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Banner title"
                                                        name='title'
                                                        value={values.title}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Offer Text</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter offer text"
                                                        name='offerText'
                                                        value={values.offerText}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Highlight Text</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter offer text"
                                                        name='highlightText'
                                                        value={values.highlightText}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Button 1 Text</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter text"
                                                        name='btn1Text'
                                                        value={values.btn1Text}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Button 1 Link</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter link"
                                                        name='btn1Link'
                                                        value={values.btn1Link}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Button 2 Text</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter text"
                                                        name='btn2Text'
                                                        value={values.btn2Text}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Button 2 Link</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter link"
                                                        name='btn2Link'
                                                        value={values.btn2Link}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">description</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={values.description}
                                                        onChange={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                description: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddBanner